import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0fdd3898&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0fdd3898&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd3898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdd3898')) {
      api.createRecord('0fdd3898', component.options)
    } else {
      api.reload('0fdd3898', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0fdd3898&scoped=true", function () {
      api.rerender('0fdd3898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-log/index.vue"
export default component.exports